import React from "react"
import {connect} from "react-redux"

import {CopyrightFooter} from "./ui/CopyrightFooter"
import DigitalToDoList from "./DigitalToDoList"

export class DigitalHomePage extends React.Component {

  render() {
    return (
      <React.Fragment>
        <DigitalToDoList/>
        <CopyrightFooter forCosco={this.props?.userProfile?.forCosco}/>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    isAppInitialized: state.app.isAppInitialized,
    userProfile: state.userProfile,
  }
}

export default connect(mapStateToProps)(DigitalHomePage)

